import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import { observable, autorun, action, toJS } from 'mobx';
import { observer } from 'mobx-react'

import {DictionaryTrans,autobind} from './DictionaryTrans';
import reactMixin  from 'react-mixin';
import SwitcherComponent from './SwitcherComponent';
import Draggable from 'react-draggable';
import {IconImage, IconText, IconTransform, IconFill, IconLayers, IconTrash, IconAdjustment, IconSettings, IconDrag} from './Icons';
import ToolbarPictures from './ToolbarPictures';
import ToolbarText from './ToolbarText';
import ToolbarSettings from './ToolbarSettings';
import ToolbarLayers from './ToolbarLayers';
import ToolbarTransform from './ToolbarTransform';
import ToolbarAdjustments from './ToolbarAdjustments';
import ToolbarBackground from './ToolbarBackground';
import Settings from './Settings';
import Delete from './Delete';

@observer
@reactMixin.decorate(DictionaryTrans)
@reactMixin.decorate(autobind(Object.keys(DictionaryTrans)))
export default class Toolbar extends Component{

  @observable trans = {  };
  @observable showContent = false;
  @observable tempShowContent = true;
  @observable showDelete = false;

  @observable menuCurrentSelected = 0;
  @observable checked = false;
  @observable rightSide = false;
  @observable style = {};

  handleToolbar = {};

  constructor(props) {

    super(props);

    this.trans = this.props.dictionaryStorage.getCurrentLangDict;

  }

  @action setCurrentSelected(item){
    if( this.menuCurrentSelected == item ){
      this.menuCurrentSelected = 0;
      Settings.setToolbarOpen(false);
      //this.showContent = false;
    }
    else
    {
      this.menuCurrentSelected = item;
      Settings.setToolbarOpen(true);
      //this.showContent = true;
      this.setPosition();
    }
    this.setPosition();
  }

  componentDidMount() {
    this.calcPosition();
    this.setPosition();

    let startDraging = false;

    $(this.handleToolbar).draggable(
      {
        handle: this.handleToolbarDrag,
        start : (e)=>{
          this.handleDragStart(e);
        },
        stop : (e)=>{
          this.handleDragStop(e);
        },
        drag : (e)=>{
          this.handleDrag(e);
        }

      });
  }


  calcPosition(){
    let container = this.handleToolbar;
    let left = $(container).offset().left;
    let width = container.offsetWidth;
    if  ( window.innerWidth / 2 - left  < 0 )
    {
      this.rightSide = true;
    }
    else
    {
      this.rightSide = false;
    }
  }

  setPosition(){

    const left = ( window.innerWidth > 1260 ? ( (window.innerWidth - 1260 ) / 2 - 25) : 0 );

    if ( this.rightSide && Settings.getSettingsToolbarOpen && this.tempShowContent ){
        this.style = {
          marginLeft : '-244px',
          width: '310px',
          left: left + 'px',
        }
    } else {
      this.style = {
        marginLeft : '0px',
        width: '50px',
        left: left + 'px',
      }
    }

    if (  Settings.getSettingsToolbarOpen && this.tempShowContent ){
      this.style = {... this.style, width : '310px' };
    }

    if ( !Settings.getSettingsToolbarOpen ){
      this.style = {... this.style, width : '50px' };
    }
      }

  handleDrag(e) {
    this.calcPosition(e.clientX);
  }

  handleDragStart(e) {
    this.tempShowContent = false;
    this.setPosition();
  }

  handleDragStop(e) {
    this.tempShowContent = true;
    this.setPosition();
  }

  onDelete(){
    bfLayers.removeLayerById(Settings.getSettingsActiveIdLayer);
    this.showDelete = false;
  }

  onCancel(){
    this.showDelete = false;
  }

  render() {

    const t = this.t;

    return (
      <div className="Toolbar" >
          <div style={this.style} ref={(input)=>{ this.handleToolbar = input }} className={"Toolbar-container " + (this.rightSide ? 'Toolbar-container-rightSide ' : '' ) + ( Settings.getSettingsToolbarOpen ? '' : 'Toolbar-container-noContent' ) }>
            <div className="Toolbar-handler" ref={(input)=>{ this.handleToolbarDrag = input }}>
              <IconDrag/>
            </div>
            <ul className="Toolbar-nav">
              <li onClick={()=>{this.setCurrentSelected('image')}} className={ (this.menuCurrentSelected == 'image' ? 'active' : '') }>
                <IconImage active={(this.menuCurrentSelected == 'image' ? 'active' : '') }/>
              </li>
              {
                ( bf_config.features.text != 'false' )
              &&
              <li onClick={()=>{this.setCurrentSelected('text')}} className={ (this.menuCurrentSelected == 'text' ? 'active' : '') }>
                <IconText active={(this.menuCurrentSelected == 'text' ? 'active' : '')}/>
              </li>
              }
              <li onClick={()=>{this.setCurrentSelected('transform')}} className={ (this.menuCurrentSelected == 'transform' ? 'active' : '') }>
                <IconTransform active={(this.menuCurrentSelected == 'transform' ? 'active' : '')}/>
              </li>
              <li onClick={()=>{this.setCurrentSelected('fill')}} className={ (this.menuCurrentSelected == 'fill' ? 'active' : '') }>
                <IconFill active={(this.menuCurrentSelected == 'fill' ? 'active' : '')}/>
              </li>
              <li onClick={()=>{this.setCurrentSelected('adjustment')}} className={ (this.menuCurrentSelected == 'adjustment' ? 'active' : '') }>
                <IconAdjustment active={(this.menuCurrentSelected == 'adjustment' ? 'active' : '')}/>
              </li>
              <li onClick={()=>{this.setCurrentSelected('layers')}} className={ (this.menuCurrentSelected == 'layers' ? 'active' : '') }>
                <IconLayers active={(this.menuCurrentSelected == 'layers' ? 'active' : '')}/>
              </li>
              <li onClick={()=>{this.setCurrentSelected('settings')}} className={ (this.menuCurrentSelected == 'settings' ? 'active' : '') }>
                <IconSettings active={(this.menuCurrentSelected == 'settings' ? 'active' : '')}/>
              </li>
              <li  className="Toolbar-trash">
                {
                  !Settings.getSettingsIsActive
                  &&
                  <div className="UniversalPrevent"></div>
                }
                <span>

                  <span onClick={()=>{  this.showDelete = !this.showDelete; }}><IconTrash /></span>
                  {
                    ( this.showDelete && Settings.getSettingsIsActive )
                    &&
                    <Delete
                      dictionaryStorage={this.props.dictionaryStorage}
                      dingsPosition="left"
                      onDelete={ ()=> { this.onDelete() } }
                      onCancel={ ()=> { this.onCancel() } }
                    />
                  }
                </span>
              </li>
            </ul>
            {
              ( Settings.getSettingsToolbarOpen && this.tempShowContent )
              &&
              <div className="Toolbar-content">
                {
                  (this.menuCurrentSelected == 'image' ? 'active' : '')
                  &&
                  <ToolbarPictures dictionaryStorage={this.props.dictionaryStorage} />
                }
                {
                  (this.menuCurrentSelected == 'text' ? 'active' : '')
                  &&
                  <ToolbarText dictionaryStorage={this.props.dictionaryStorage} />
                }
                {
                  (this.menuCurrentSelected == 'transform' ? 'active' : '')
                  &&
                  <ToolbarTransform dictionaryStorage={this.props.dictionaryStorage} />
                }
                {
                  (this.menuCurrentSelected == 'fill' ? 'active' : '')
                  &&
                  <ToolbarBackground dictionaryStorage={this.props.dictionaryStorage} />
                }
                {
                  (this.menuCurrentSelected == 'adjustment' ? 'active' : '')
                  &&
                  <ToolbarAdjustments dictionaryStorage={this.props.dictionaryStorage} />
                }
                {
                  (this.menuCurrentSelected == 'layers' ? 'active' : '')
                  &&
                  <ToolbarLayers dictionaryStorage={this.props.dictionaryStorage} />
                }
                {
                  (this.menuCurrentSelected == 'settings' ? 'active' : '')
                  &&
                  <ToolbarSettings dictionaryStorage={this.props.dictionaryStorage} />
                }

              </div>
            }

          </div>
        </div>
    );

   // ReactDOM.render(dom, document.getElementById('transforms'));

  }
}

/*
 <Draggable
 onStart={ (e)=> { this.handleDragStart(e) } }
 onStop={ (e)=> { this.handleDragStop(e) } }
 onDrag={ (e)=> { this.handleDrag(e) } }
 handle=".Toolbar-handler"
 defaultPosition={{x: 10, y: 90}} >
 </Draggable>
 */
